export default __webpack_public_path__ + "static/media/upArrow.91736d17.png";